import React from 'react';
import { Meeting } from '../../services/meetingService';
import {
  parseWorkshopCalendar,
  formatCalendarDateLabel,
  formatCalendarStepLabel,
  shouldShowWorkshopCalendar,
  calendarHasContent,
} from '../../data/workshopCalendar';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopCalendarMemberViewProps {
  meeting: Meeting | null;
}

function CalendarStatusLine({ label, value }: { label: string; value: string }) {
  return (
    <p className={styles.calendarStatusLine}>
      {label}: <strong>{value}</strong>
    </p>
  );
}

const WorkshopCalendarMemberView: React.FC<WorkshopCalendarMemberViewProps> = ({ meeting }) => {
  const cal = parseWorkshopCalendar(meeting);

  if (!shouldShowWorkshopCalendar(meeting)) {
    return (
      <p className={styles.comingSoonNote}>
        The step calendar will appear here once the workshop is underway.
      </p>
    );
  }

  if (!calendarHasContent(cal)) {
    return (
      <p className={styles.comingSoonNote}>
        Calendar details will be posted here as the group progresses.
      </p>
    );
  }

  const stepLabel = formatCalendarStepLabel(cal);

  return (
    <div className={styles.calendarStatusList}>
      {stepLabel && <CalendarStatusLine label="Current step" value={stepLabel} />}
      {cal.step_started_date && (
        <CalendarStatusLine
          label="We started this step"
          value={formatCalendarDateLabel(cal.step_started_date)}
        />
      )}
      {cal.where_we_are?.trim() && (
        <CalendarStatusLine label="Where we are" value={cal.where_we_are.trim()} />
      )}
      {cal.likely_complete?.trim() && (
        <CalendarStatusLine
          label="Likely complete"
          value={formatCalendarDateLabel(cal.likely_complete) || cal.likely_complete.trim()}
        />
      )}
    </div>
  );
};

export default WorkshopCalendarMemberView;
